export const hostUrl = 'https://api.preventms.fr';
//export const hostUrl = 'http://localhost/prevent-tms-api/public';


// WEBPACK FOOTER //
// ./src/_helpers/global_var.js